<template>
  <FormulateInput
    ref="boxInput"
    :type="type"
    v-bind="$attrs"
    :key="value"
    :value="value"
    :checked="checked"
    @input="$emit('input', $event)"
  />
</template>

<script>
import { nextTick, onMounted, ref } from '@vue/composition-api';
import { nodeListToArray } from '@/lego/utils/dom/object';

export default {
  props: {
    type: {
      type: String,
      default: 'checkbox',
    },
    value: {
      type: String,
    },
    checked: {
      type: Boolean,
    },
  },
  setup(props, { emit, root }) {
    const boxInput = ref();
    const go = () => {
      emit('go');
    };

    onMounted(() => {
      nextTick(() =>
        setTimeout(() => {
          var els = nodeListToArray(
            boxInput.value.$el.querySelectorAll('.formulate-input'),
          );

          els.forEach(el => {
            var input = el.querySelector('input');
            var label = el.querySelector('.formulate-input-label');

            input.addEventListener('change', go);
            label.addEventListener('click', () => {
              if (input.checked) {
                go();
              }
            });
          });
        }, 100),
      );
    });

    return {
      boxInput,
    };
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .formulate-input {
  &-label {
    @apply px-nano hover:cursor-pointer;
  }

  &-wrapper {
    @apply flex items-center;
  }

  &-element {
    @apply flex;
  }
}
</style>
